export const titleCase = word =>
  word.replace(/^_*(.)|_+(.)/g, (s, c, d) =>
    c ? c.toUpperCase() : ` ${d.toUpperCase()}`
  );
